import { render, staticRenderFns } from "./SlaTimeByOwner.vue?vue&type=template&id=4f3bf6cd&scoped=true&"
import script from "./SlaTimeByOwner.vue?vue&type=script&lang=js&"
export * from "./SlaTimeByOwner.vue?vue&type=script&lang=js&"
import style0 from "./SlaTimeByOwner.vue?vue&type=style&index=0&id=4f3bf6cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3bf6cd",
  null
  
)

export default component.exports